import React from 'react';

import { Box, Grid, Typography, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import parse from 'html-react-parser';

import StyledJadeSoftTeam from './styles';

//icon jadesoft team
import { useTranslation } from 'react-i18next';
import IconSolution4 from '../../../components/Icons/IconSolution/IconSolution4';
import IconSolution5 from '../../../components/Icons/IconSolution/IconSolution5';
import IconSolution7 from '../../../components/Icons/IconSolution/IconSolution7';
import IconSolution8 from '../../../components/Icons/IconSolution/IconSolution8';

// import { S3 } from '../../../config/api';

// const bannerText =
// 'Reinventing the platform and developing one from scratch — the Jade Soft team is ready to take on your challenges and create an outstanding tailored iGaming solution';

const JadeSoftTeam = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  const label = t('jadesoftteam-content');

  const jadeSoftTeam = [
    {
      id: 1,
      title: t('jadesoftteam-title-one'),
      content: t('jadesoftteam-content-one'),
      image: <IconSolution5 />,
      delay: 0.3,
    },
    {
      id: 2,
      title: t('jadesoftteam-title-two'),
      content: t('jadesoftteam-content-two'),
      image: <IconSolution7 />,
      delay: 0.3,
    },
    {
      id: 3,
      title: t('jadesoftteam-title-three'),
      content: t('jadesoftteam-content-three'),
      image: <IconSolution8 />,
      delay: 0.6,
    },
    {
      id: 4,
      title: t('jadesoftteam-title-four'),
      content: t('jadesoftteam-content-four'),
      image: <IconSolution4 />,
      delay: 0.6,
    },
  ];

  return (
    <StyledJadeSoftTeam>
      <Box className="homeBg">
        {/* <img className="bgImage" src={JadeSoftTeamImage} /> */}
        <Box
          sx={{
            textAlign: { xs: 'center', md: 'center' },
            zIndex: 1,
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent black overlay
            zIndex: 1,
            padding: '5% 25% 3% 25%',
            [theme.breakpoints.down('lg')]: {
              padding: '20% 6% 10px 6%',
            },
          }}
        >
          <Typography
            variant="h2"
            component="h2"
            sx={{
              fontSize: '64px',
              fontWeight: '800',
              lineHeight: '76.38px',
              [theme.breakpoints.down('lg')]: {
                fontSize: '40px',
                fontWeight: 800,
                lineHeight: '47.73px',
              },
            }}
          >
            {/* <motion.div
              initial={{
                opacity: 0,
                y: 100,
              }}
              whileInView={{
                opacity: 1,
                y: 0, // Slide in to its original position
                transition: {
                  duration: 1, // Animation duration
                },
              }}
            // viewport={{ once: true }}
            > */}
            {t('jadesoftteam-header')}
            {/* </motion.div> */}
          </Typography>
          <Typography
            variant="h2"
            component="h2"
            sx={{
              fontSize: '32px',
              fontWeight: '700',
              lineHeight: '38.19px',
              marginTop: 3,
              [theme.breakpoints.down('lg')]: {
                fontSize: '24px',
                fontWeight: 700,
                lineHeight: '28.64px',
                mb: 3,
              },
            }}
          >
            {/* <motion.div
              initial={{
                opacity: 0,
                y: 100,
              }}
              whileInView={{
                opacity: 1,
                y: 0, // Slide in to its original position
                transition: {
                  duration: 1, // Animation duration
                  delay: 0.8,
                },
              }}
            // viewport={{ once: true }}
            > */}
            {t('jadesoftteam-sub-header')}
            {/* </motion.div> */}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
            }}
          >
            <Typography
              variant="body1"
              sx={{
                lineHeight: 1.8,
                wordWrap: 'break-word',
                fontWeight: localStorage.getItem('i18nextLng') === 'en-US' ? '600' : '700',
                fontSize: '20px',
                mt: 3,
                lineHeight: '23.87px',
                color: "#E8E8E8",
                [theme.breakpoints.down('lg')]: {
                  fontSize: '18px',
                  fontWeight: 600,
                  lineHeight: '23.4px',
                  mt: 0
                },
              }}
              className='label'
            >
              {/* <motion.div
                initial={{
                  opacity: 0,
                  y: 100,
                }}
                whileInView={{
                  opacity: 1,
                  y: 0, // Slide in to its original position
                  transition: {
                    duration: 1, // Animation duration
                    delay: 0.8,
                  },
                }}
              // viewport={{ once: true }}
              > */}
              {parse(label)}
              {/* </motion.div> */}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box className="homeContent">
        {/* <Box className="iconBrandLogo" sx={{ height: '170px' }}>
            <IconBrandLogo />
          </Box> */}
        <Box
          mt={15}
          mb={15}
          display={'flex'}
          justifyContent={'center'}
          sx={{
            maxWidth: '100%', maxHeight: '100%', color: '#000000', [theme.breakpoints.down('lg')]: {
              mt: 1,
              mb: 8
            },
          }}
        >
          <Grid container spacing={2} rowSpacing={{ xs: 0, md: 15, lg: 15, xl: 15 }}>
            {jadeSoftTeam.map((item, index) => (
              <Grid item xs={12} sm={12} md={12} lg={6} xl={6} key={index}
                sx={{
                  paddingTop: '50px !important', [theme.breakpoints.down('lg')]: {

                  },
                }}
              >
                <motion.div
                  initial={{
                    opacity: 0,
                    y: 70,
                  }}
                  whileInView={{
                    opacity: 1,
                    y: 0, // Slide in to its original position
                    transition: {
                      duration: 1, // Animation duration
                      delay: item.delay,
                    },
                  }}
                // viewport={{ once: true }}
                >
                  <Box sx={{ maxWidth: '100%', maxHeight: '100%', mt: 3 }} display={'flex'} key={item.id}>
                    <Box
                      sx={{
                        backgroundColor: '#ffffff',
                        textAlign: 'center',
                        paddingLeft: 0,
                        paddingRight: 0,
                        // width: '628px',
                        // height: '321.56px',
                        //   maxWidth: '628px',
                        maxHeight: '100%',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      }}
                    >
                      <Box
                        sx={{
                          [theme.breakpoints.down('lg')]: {
                            height: '115px',
                            width: '115px',
                            display: 'unset',
                            justifySelf: 'center',
                          },
                        }}
                      >
                        {item.image}
                      </Box>
                      <Typography
                        variant="body1"
                        sx={{
                          mt: 2,
                          mb: 2,
                          lineHeight: '40.57px',
                          wordWrap: 'break-word',
                          fontWeight: 800,
                          fontSize: '34px',
                          color: '#444444',
                          [theme.breakpoints.down('lg')]: {
                            mt: 1,
                            fontSize: '24px',
                            fontWeight: 800,
                            lineHeight: '28.64px',
                            mb: 2,
                          },
                        }}
                        className='title'
                      >
                        {item.title}
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          mb: 0,
                          lineHeight: '23.87px',
                          wordWrap: 'break-word',
                          fontWeight: 600,
                          fontSize: '20px',
                          color: '#676767',
                          [theme.breakpoints.down('lg')]: {
                            mt: 1,
                            fontSize: '16px',
                            fontWeight: 500,
                            lineHeight: '19.09px',
                          },
                        }}
                        className='content'
                      >
                        {parse(item.content)}
                      </Typography>
                    </Box>
                  </Box>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </StyledJadeSoftTeam >
  );
};

export default JadeSoftTeam;
